import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '../../themed/button';
import Header from '../../blocks/header';

import unauthorized from '../../../assets/images/unauthorized.png';
import classNames from './style.module.scss';
import routes from '../../../utils/routes';

const Unauthorized: React.FC = () => {
	const navigate = useNavigate();

	return (
		<React.Fragment>
			<Header subtitle="Unauthorized Page" />

			<div className={classNames.unauthorized}>
				<div className={classNames.unauthorizedBody}>
					<div className={classNames.unauthorizedBodyImage}>
						<img src={unauthorized} alt="Unauthorized" />
					</div>
					<div className={classNames.unauthorizedBodyDetails}>
						<h2> <i className="bi bi-lock"></i> Show ID!</h2>
						<p>You're not permitted to view this page! You may want to show Identification</p>
						<Button icon='house' label='Go home' onClick={() => navigate(routes.dashboard.fullPath)}/>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Unauthorized;
